import { styled } from "styled-components";

export const WrapperErrorBoundaryStyled = styled.div`
  height: 100vh;
  background-size: cover;
  background-size: cover;
  background-repeat: no-repeat;
`;
